import Vue from 'vue'
import App from './App'
import router from './router'
import api from './http'
import wmsApi from './http'
import i18n from './i18n'
import store from './store'
import global from '@/utils/global'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import '@/assets/iconfont/iconfont.css'
// 引入全局样式文件
import '@/assets/css/global.css'
// import jsCookie from 'js-cookie';

Vue.use(ElementUI)

Vue.use(api)
Vue.use(wmsApi)

Vue.prototype.global = global
// Vue.prototype.$cookie = jsCookie;

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js